import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteNav } from '@/components/generals/site-nav'
import { SiteFooter } from '@/components/generals/site-footer'
import { TrialDialog } from '@/components/generals/trial-dialog'
import { TrialProvider } from '@/components/generals/trial-provider'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <TrialProvider>
            <a
                href='#main'
                className='sr-only rounded-full bg-ink px-5 py-3 text-sm font-semibold text-white focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60]'
            >
                Skip to content
            </a>

            <div className='flex min-h-screen flex-col'>
                <SiteNav />

                <main id='main' className='flex-1'>
                    {children}
                </main>

                <SiteFooter />
            </div>

            <TrialDialog />
        </TrialProvider>
    )
}
